import { Component, Input } from '@angular/core';

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    standalone: false
})
export class FeedbackComponent {

    @Input() data:any;

    constructor(){}

}

